import { connect } from 'react-redux'
import GroupsBulkAction from './groups-bulk-action'
import {
  getSelectedGroupsIdsArray,
  isShowingSelected
} from '../groups-component-redux/groups-component-redux.selectors'
import {
  showSelectedGroups,
  unsetShowSelectedGroups
} from '../groups-component-redux/groups-component-redux.actions'
import { deleteGroup } from '../../../../stores/groups/groups.actions'
import { openSetVisibilityDialog } from '../dialogs/set-visibility/set-visibility.actions'
import { getGroups } from '../../../../stores/groups/groups.selectors'

const mapStateToProps = state => ({
  groups: getGroups(state),
  selectedGroups: getSelectedGroupsIdsArray(state),
  showingSelected: isShowingSelected(state)
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  deleteGroup: () =>
    stateProps.selectedGroups.forEach(id => dispatch(deleteGroup(id))),
  showSelected: () => dispatch(showSelectedGroups()),
  showAll: () => dispatch(unsetShowSelectedGroups()),
  onSetVisibility: () =>
    dispatch(openSetVisibilityDialog(stateProps.selectedGroups))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(GroupsBulkAction)
